import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import { GmbMediaStorageType } from "@/enums/gmb-media-storage-type.js";

export default {
  getPhotos(params) {
    return apiService.get(endpoints.gmbMedia, { params });
  },

  postPhoto(form) {
    return apiService.post(endpoints.gmbMedia, form);
  },

  deletePhoto(id) {
    return apiService.delete(endpoints.gmbMediaId(id));
  },

  getMediaTypes() {
    return apiService.get(endpoints.gmbMediaTypes);
  },

  getImageUrl(form) {
    form.append("type", GmbMediaStorageType.PHOTO);
    return apiService.post(endpoints.gmbMediaStorage, form);
  },

  setStoreLocatorVisibility(photoId, visible) {
    if (visible) {
      return apiService.post(endpoints.gmbMediaStoreLocator(photoId));
    } else {
      return apiService.delete(endpoints.gmbMediaStoreLocator(photoId));
    }
  }
};
